import React from 'react';
export function Timeline() {
  return <section className="mb-24" data-id="element-552">
      <h2 className="text-[28px] sm:text-[32px] md:text-[36px] font-semibold text-[#1B2951] mb-8 leading-tight font-['Playfair_Display']" data-id="element-553">
        Your Transformation Timeline
      </h2>
      <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-554">
        {/* Transformation Image */}
        <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 border border-[#7F8C8D]/10" data-id="element-555">
          <h3 className="text-xl font-semibold text-[#1B2951] mb-4 font-['Poppins']" data-id="element-556">
            See Your Transformation Unfold
          </h3>
          <div className="relative" data-id="element-557">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YJ95Hz3AWJG3LgfDzdmxL/u8357357769_Create_a_series_of_5_portrait_photos_of_the_same__e6b46230-ab5f-4cbc-9ba3-16c69f804693_2.png" alt="Progressive skin transformation showing improvement over time from day 1 to day 90" className="w-full h-auto rounded-lg" data-id="element-558" />
            {/* Day markers */}
            <div className="absolute top-2 left-2 bg-gradient-to-r from-[#FFB88C] to-[#FFE5D9] text-[#1B2951] px-3 py-1 text-sm font-medium rounded-md" data-id="element-559">
              Day 1
            </div>
            <div className="absolute top-2 right-2 bg-gradient-to-r from-[#FFB88C] to-[#FFE5D9] text-[#1B2951] px-3 py-1 text-sm font-medium rounded-md" data-id="element-560">
              Day 15
            </div>
            <div className="absolute bottom-2 left-2 bg-gradient-to-r from-[#FFB88C] to-[#FFE5D9] text-[#1B2951] px-3 py-1 text-sm font-medium rounded-md" data-id="element-561">
              Day 45
            </div>
            <div className="absolute bottom-2 right-2 bg-gradient-to-r from-[#FFB88C] to-[#FFE5D9] text-[#1B2951] px-3 py-1 text-sm font-medium rounded-md" data-id="element-562">
              Day 90
            </div>
          </div>
          <p className="text-[#7F8C8D] text-sm italic mt-4 text-center font-['Inter']" data-id="element-563">
            Real results from a 45-year-old customer showing progressive
            improvement in skin texture, tone, and radiance
          </p>
        </div>
        {/* Timeline Steps */}
        <div className="relative" data-id="element-564">
          {/* Timeline line */}
          <div className="absolute top-0 left-4 h-full w-0.5 bg-[#FFB88C]/30 hidden md:block" data-id="element-565"></div>
          <div className="space-y-6" data-id="element-566">
            <div className="relative flex items-start md:items-center" data-id="element-567">
              <div className="hidden md:flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-r from-[#FF8E72] to-[#FFB88C] text-white font-bold shrink-0 z-10 font-['Poppins']" data-id="element-568">
                1
              </div>
              <div className="md:ml-6 bg-white rounded-lg p-5 md:w-[calc(100%-50px)] border border-[#7F8C8D]/10 shadow-sm hover:shadow-md transition-all duration-300" data-id="element-569">
                <h3 className="text-lg font-semibold text-[#1B2951] mb-2 md:hidden font-['Poppins']" data-id="element-570">
                  Day 1-7:
                </h3>
                <div className="flex md:items-center" data-id="element-571">
                  <div className="hidden md:block w-24 font-semibold text-[#1B2951] font-['Poppins']" data-id="element-572">
                    Day 1-7:
                  </div>
                  <div className="text-[#2C3E50] font-['Inter']" data-id="element-573">
                    <p className="font-medium" data-id="element-574">Ceramides begin to work</p>
                    <p className="text-sm text-[#7F8C8D]" data-id="element-575">
                      Your skin barrier starts strengthening
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative flex items-start md:items-center" data-id="element-576">
              <div className="hidden md:flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-r from-[#FF8E72] to-[#FFB88C] text-white font-bold shrink-0 z-10 font-['Poppins']" data-id="element-577">
                2
              </div>
              <div className="md:ml-6 bg-white rounded-lg p-5 md:w-[calc(100%-50px)] border border-[#7F8C8D]/10 shadow-sm hover:shadow-md transition-all duration-300" data-id="element-578">
                <h3 className="text-lg font-semibold text-[#1B2951] mb-2 md:hidden font-['Poppins']" data-id="element-579">
                  Day 7-15:
                </h3>
                <div className="flex md:items-center" data-id="element-580">
                  <div className="hidden md:block w-24 font-semibold text-[#1B2951] font-['Poppins']" data-id="element-581">
                    Day 7-15:
                  </div>
                  <div className="text-[#2C3E50] font-['Inter']" data-id="element-582">
                    <p className="font-medium" data-id="element-583">First visible changes</p>
                    <p className="text-sm text-[#7F8C8D]" data-id="element-584">
                      Improved hydration and subtle glow
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative flex items-start md:items-center" data-id="element-585">
              <div className="hidden md:flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-r from-[#FF8E72] to-[#FFB88C] text-white font-bold shrink-0 z-10 font-['Poppins']" data-id="element-586">
                3
              </div>
              <div className="md:ml-6 bg-white rounded-lg p-5 md:w-[calc(100%-50px)] border border-[#7F8C8D]/10 shadow-sm hover:shadow-md transition-all duration-300" data-id="element-587">
                <h3 className="text-lg font-semibold text-[#1B2951] mb-2 md:hidden font-['Poppins']" data-id="element-588">
                  Day 15-45:
                </h3>
                <div className="flex md:items-center" data-id="element-589">
                  <div className="hidden md:block w-24 font-semibold text-[#1B2951] font-['Poppins']" data-id="element-590">
                    Day 15-45:
                  </div>
                  <div className="text-[#2C3E50] font-['Inter']" data-id="element-591">
                    <p className="font-medium" data-id="element-592">Dramatic transformation</p>
                    <p className="text-sm text-[#7F8C8D]" data-id="element-593">
                      Fine lines soften, skin tone evens out
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative flex items-start md:items-center" data-id="element-594">
              <div className="hidden md:flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-r from-[#FF8E72] to-[#FFB88C] text-white font-bold shrink-0 z-10 font-['Poppins']" data-id="element-595">
                4
              </div>
              <div className="md:ml-6 bg-white rounded-lg p-5 md:w-[calc(100%-50px)] border border-[#7F8C8D]/10 shadow-sm hover:shadow-md transition-all duration-300" data-id="element-596">
                <h3 className="text-lg font-semibold text-[#1B2951] mb-2 md:hidden font-['Poppins']" data-id="element-597">
                  Day 45-60:
                </h3>
                <div className="flex md:items-center" data-id="element-598">
                  <div className="hidden md:block w-24 font-semibold text-[#1B2951] font-['Poppins']" data-id="element-599">
                    Day 45-60:
                  </div>
                  <div className="text-[#2C3E50] font-['Inter']" data-id="element-600">
                    <p className="font-medium" data-id="element-601">Hair benefits appear</p>
                    <p className="text-sm text-[#7F8C8D]" data-id="element-602">
                      Reduced hair fall, improved texture
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative flex items-start md:items-center" data-id="element-603">
              <div className="hidden md:flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-r from-[#FF8E72] to-[#FFB88C] text-white font-bold shrink-0 z-10 font-['Poppins']" data-id="element-604">
                5
              </div>
              <div className="md:ml-6 bg-white rounded-lg p-5 md:w-[calc(100%-50px)] border border-[#7F8C8D]/10 shadow-sm hover:shadow-md transition-all duration-300" data-id="element-605">
                <h3 className="text-lg font-semibold text-[#1B2951] mb-2 md:hidden font-['Poppins']" data-id="element-606">
                  Day 60-90:
                </h3>
                <div className="flex md:items-center" data-id="element-607">
                  <div className="hidden md:block w-24 font-semibold text-[#1B2951] font-['Poppins']" data-id="element-608">
                    Day 60-90:
                  </div>
                  <div className="text-[#2C3E50] font-['Inter']" data-id="element-609">
                    <p className="font-medium" data-id="element-610">Complete transformation</p>
                    <p className="text-sm text-[#7F8C8D]" data-id="element-611">
                      Radiant, youthful skin that turns heads
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#FFF8F3] p-6 rounded-lg border border-[#FFB88C]/20 text-center" data-id="element-612">
        <p className="text-lg text-[#1B2951] font-medium italic font-['Inter']" data-id="element-613">
          "Our customers see visible changes by day 15, but the full
          transformation journey unfolds over 90 days as your skin rebuilds from
          within."
        </p>
        <p className="text-[#2C3E50] mt-2 font-['Inter']" data-id="element-614">
          - Nihaal Mariwala, Founder
        </p>
      </div>
    </section>;
}